<template>
  <div class="navigation">
    <div class="nav-content" style="float: right;">
      <router-link :to="{path: '/'}" style="position: absolute;right: 1460px;margin-top: -5px"><img
          class="nav-logo" style="width: 80px;height: 80px" src="../assets/images/header-logo_nm.png"/></router-link>
      <router-link :to="{path: '/'}"
                   style="position: absolute;right: 1065px;top:32px;width: 375px;font-size: 22px;margin-top: 10px;font-family: 宋体;font-weight: bold">
        {{ clientTitle }}
      </router-link>
      <el-row class="tool-btn" v-if="false">
        <el-col :offset="5" :span="8" style="margin-right: 0px;cursor: pointer;">
          <span class="nav-menu-a" :style="(parentButton == 1 ? 'color:blue;':'') + 'font-size:19px'"
                @click="toNewSitePage">
          电子标识申请推荐通道
          </span>
        </el-col>
<!--        <el-col :span="8" style="cursor: pointer;">-->
<!--          <span class="nav-menu-a" :style="(parentButton == 2 ? 'color:blue;':'') + 'font-size:19px'"-->
<!--                @click="toOldSitePage">区局电子标识申请通道</span>-->
<!--        </el-col>-->
      </el-row>
      <el-row class="tool-btn" style="margin-bottom: -10px;" v-if="parentButton == 2">
        <el-col :span="24" v-if="parentButton == 2">
          <router-link :class="this.$store.state.navRouter=='signApply'?'nav-menu-a nav-currrnt-menu':'nav-menu-a'"
                       :to="{path: '/signApply'}">电子标识申请
          </router-link>
          <router-link :class="this.$store.state.navRouter=='applyStep'?'nav-menu-a nav-currrnt-menu':'nav-menu-a'"
                       :to="{path: '/applyStep'}">申请步骤
          </router-link>
          <router-link :class="this.$store.state.navRouter=='siteBook'?'nav-menu-a nav-currrnt-menu':'nav-menu-a'"
                       :to="{path: '/siteBook'}">亮照告知书
          </router-link>
          <router-link :class="this.$store.state.navRouter=='index'?'nav-menu-a nav-currrnt-menu':'nav-menu-a'"
                       :to="{path: '/index'}">申请公示
          </router-link>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import dragVerify from 'vue-drag-verify'
import {getClientTitle1} from '../assets/js/utils'

export default {
  name: 'navigation',
  components: {
    dragVerify
  },

  data () {
    return {
      parentButton: 1,
      clientTitle: null,
      loginDialogVisible: false,
      touch: {
        circle: false,
        textSize: '13px'

      }
    }
  },

  created () {
    if (this.$route.path == '/newSitePage') {
      this.parentButton = 1
    } else {
      this.parentButton = 2
    }
    var _self = this
    getClientTitle1(_self, function (res) {
      _self.clientTitle = res
    })
    let user = this.$cookies.get('user')
    if (user) {
      this.nickName = user.nickName
    }
  },
  methods: {
    toNewSitePage () {
      this.parentButton = 1
      this.$router.push({
        path: '/newSitePage'
      })
    },
    toOldSitePage () {
      this.parentButton = 2
      this.$router.push({
        path: '/index'
      })
    }
  }
}
</script>

<style>

/*登录弹窗结束*/
.navigation {
  width: 100%;
  height: 110px;
  background-color: #FFFFFF;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
  margin: 0 auto;
}
.nav-currrnt-menu {
  color: black !important;
  border-bottom: 2px solid #000000;
}

.nav-content {
  width: 1200px;
  height: 80px;
  padding-top: 22.5px;
  padding-right: 400px;
  margin: 0 auto;
  position: relative;
}

.nav-content .nav-logo {
  float: left;
  height: 45px;
  margin-left: -3px;
}

.nav-content .nav-menu-a {
  float: right;
  color: #878787;
  font-size: 16px;
  display: block;
  height: 30px;
  line-height: 30px;
  margin-left: 20px;
  margin-top: 7.5px;
}

.nav-content .nav-menu-a:not(:first-child) {
  margin-left: 18px;
}

.nav-content .nav-menu-a:hover {
  color: #000000;
}

.right-tip a {
  cursor: pointer
}
</style>



// WEBPACK FOOTER //
// src/components/navigation.vue